import { gqlQuery } from '@hapana/shared/web/services/requests.service'

import { analyticsV2QueryMeasureQuery } from './graphql/analytics-v2.queries'

export const ANALYTICS_V2_QUERY_MEASURE_KEY = 'ANALYTICS_V2_QUERY_MEASURE' as const

export const queryAnalyticsV2Measure = gqlQuery({
  key: ANALYTICS_V2_QUERY_MEASURE_KEY,
  query: analyticsV2QueryMeasureQuery,
})
